/* jshint esversion: 6 */
/* jshint ignore:start */

import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { showToast } from "../../showTost";
import { useContext } from "react";
import { MyContext } from "../../Context/MyProvider";

const Dashboard = () => {

    const { setIsLogin } = useContext(MyContext);

    const { t } = useTranslation();

    const Navigate = useNavigate();

    const site_currency = secureLocalStorage.getItem("currency");
    const currency = site_currency ? site_currency : "$";
    const LoginData = secureLocalStorage.getItem("Loginuser");

    if (LoginData) {
        var { name, referral_code, date } = JSON.parse(LoginData);
    }

    const menuItems = [
        {
            icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 7.5C3 5.29086 4.79086 3.5 7 3.5H17C19.2091 3.5 21 5.29086 21 7.5V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V7.5Z" stroke="currentColor" strokeWidth="1.5" />
                <path d="M3 9H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 2L8 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M16 2V5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="12" cy="15" r="1" fill="currentColor" />
                <circle cx="16" cy="15" r="1" fill="currentColor" />
                <circle cx="8" cy="15" r="1" fill="currentColor" />
            </svg>, label: 'My Booking', href: '/booking', color: 'from-blue-500 to-blue-600'
        },
        {
            icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.5583 4.79151C12.947 2.40283 16.8198 2.40283 19.2085 4.79151C21.5972 7.18019 21.5972 11.053 19.2085 13.4417L13.4417 19.2085C11.053 21.5972 7.18019 21.5972 4.79151 19.2085C2.40283 16.8198 2.40283 12.947 4.79151 10.5583L10.5583 4.79151Z" stroke="currentColor" strokeWidth="1.5" />
                <path d="M16.9497 7.05029C18.1213 8.22187 18.1213 10.1214 16.9497 11.2929" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7.75732 7.75732L16.2426 16.2426" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>, label: 'My Order', href: '/order', color: 'from-teal-500 to-teal-600'
        },
        {
            icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.8887 6.1416L17.8583 11.1113L8.74728 20.2223C7.37494 21.5947 5.14995 21.5947 3.77761 20.2223V20.2223C2.40528 18.85 2.40527 16.625 3.77761 15.2527L12.8887 6.1416Z" stroke="currentColor" strokeWidth="1.5" />
                <path d="M17.03 3.65656C17.9449 2.74167 19.4282 2.74167 20.3431 3.65656V3.65656C21.258 4.57145 21.258 6.05478 20.3431 6.96967L19.5148 7.79795L16.2017 4.48483L17.03 3.65656Z" stroke="currentColor" strokeWidth="1.5" />
                <path d="M12.4744 3.24242C13.1605 2.55625 14.273 2.55625 14.9592 3.24242L20.7572 9.04036C21.4433 9.72653 21.4433 10.839 20.7572 11.5252V11.5252C20.071 12.2114 18.9585 12.2114 18.2723 11.5252L12.4744 5.72725C11.7882 5.04108 11.7882 3.92859 12.4744 3.24242V3.24242Z" stroke="currentColor" strokeWidth="1.5" />
                <path d="M6 13L15 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>, label: 'Booking Package', href: '/booking-package', color: 'from-green-500 to-green-600'
        },
        {
            icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.9394 12.4131H15.9484" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11.9304 12.4131H11.9394" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M7.9214 12.4131H7.9304" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path fillRule="evenodd" clipRule="evenodd" d="M19.071 19.0698C16.0159 22.1264 11.4896 22.7867 7.78631 21.074C7.23961 20.8539 3.70113 21.8339 2.93334 21.067C2.16555 20.2991 3.14639 16.7601 2.92631 16.2134C1.21285 12.5106 1.87411 7.9826 4.9302 4.9271C8.83147 1.0243 15.1698 1.0243 19.071 4.9271C22.9803 8.83593 22.9723 15.1681 19.071 19.0698Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>, label: 'Chat', href: '/chat', color: 'from-purple-500 to-purple-600'
        },
        {
            icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.6831 10.0808L14.3138 10.4866L13.6831 10.0808ZM9.25 9C9.25 9.41421 9.58579 9.75 10 9.75C10.4142 9.75 10.75 9.41421 10.75 9H9.25ZM11.25 13.5C11.25 13.9142 11.5858 14.25 12 14.25C12.4142 14.25 12.75 13.9142 12.75 13.5H11.25ZM12.75 16C12.75 15.5858 12.4142 15.25 12 15.25C11.5858 15.25 11.25 15.5858 11.25 16H12.75ZM11.25 17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17H11.25ZM21.25 12C21.25 17.1086 17.1086 21.25 12 21.25V22.75C17.9371 22.75 22.75 17.9371 22.75 12H21.25ZM12 21.25C6.89137 21.25 2.75 17.1086 2.75 12H1.25C1.25 17.9371 6.06294 22.75 12 22.75V21.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75V1.25C6.06294 1.25 1.25 6.06294 1.25 12H2.75ZM12 2.75C17.1086 2.75 21.25 6.89137 21.25 12H22.75C22.75 6.06294 17.9371 1.25 12 1.25V2.75ZM13.25 9C13.25 9.24996 13.1774 9.48068 13.0524 9.67495L14.3138 10.4866C14.5899 10.0576 14.75 9.54634 14.75 9H13.25ZM10.75 9C10.75 8.30964 11.3096 7.75 12 7.75V6.25C10.4812 6.25 9.25 7.48122 9.25 9H10.75ZM12 7.75C12.6904 7.75 13.25 8.30964 13.25 9H14.75C14.75 7.48122 13.5188 6.25 12 6.25V7.75ZM11.25 13V13.5H12.75V13H11.25ZM13.0524 9.67495C12.9265 9.87065 12.7688 10.0731 12.5836 10.3033C12.4063 10.5237 12.1979 10.7764 12.011 11.0333C11.6424 11.5398 11.25 12.2007 11.25 13H12.75C12.75 12.6947 12.9003 12.3605 13.2239 11.9158C13.383 11.697 13.558 11.4851 13.7523 11.2436C13.9387 11.0119 14.1409 10.7554 14.3138 10.4866L13.0524 9.67495ZM11.25 16V17H12.75V16H11.25Z" fill="currentColor" />
            </svg>, label: 'FAQs', href: '/faq', color: 'from-indigo-500 to-indigo-600'
        },

    ];


    const HandleLogOut = () => {
        const Loginuser = secureLocalStorage.getItem("Loginuser");
        if (Loginuser) {
            showToast({ title: t("Logout Successful!"), id: "success" });
            Navigate("/");
            setIsLogin("1");
            secureLocalStorage.clear();
            sessionStorage.clear();
        }
    };

    return (
        <div className='w-full width-container content-wrapper'>

            <div className="flex items-center justify-between mb-6 bg-white shadow px-[20px] py-[15px] rounded-[15px]">
                <div className="leading-4">
                    <h1 className="text-3xl font-bold text-gray-900">{t("Welcome back")}, {name}!</h1>
                    <p className="text-gray-600 mt-1">{t("Manage your health services")}</p>
                </div>
                <button onClick={HandleLogOut} className="inline-flex items-center justify-center whitespace-nowrap rounded-xl text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border-2 border-[#4038FF] bg-transparent text-[#4038FF] hover:bg-[#4038FF] hover:text-white h-11 px-6 py-2 gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="m16 17 5-5-5-5"></path>
                        <path d="M21 12H9"></path>
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                    </svg>
                    {t("Logout")}
                </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-5">

                <Link to="/wallet">
                    <div className="rounded-xl border border-gray-200 shadow-sm bg-[#4038FF]/90 text-white hover:shadow-xl hover:scale-105 transition-all cursor-pointer">
                        <div className="p-6">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-white/80 text-sm">{t("Wallet Balance")}</p>
                                    <p className="text-3xl font-bold mt-1">{currency + secureLocalStorage.getItem("wallet")}</p>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-12 h-12 opacity-50" aria-hidden="true">
                                    <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"></path><path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </Link>

                <Link to="/refer-and-earn">
                    <div className="rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-xl hover:scale-105 transition-all cursor-pointer">
                        <div className="p-6">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-gray-600 text-sm">{t("Refer & Earn")}</p>
                                    <p className="text-2xl font-bold mt-1 text-[#4038FF]">
                                        {referral_code}
                                    </p>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-12 h-12 text-gray-300" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"></rect><path d="M12 8v13"></path><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"></path></svg>
                            </div>
                        </div>
                    </div>
                </Link>

                <Link to="/profile">
                    <div className="rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-xl hover:scale-105 transition-all cursor-pointer">
                        <div className="p-6">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-gray-600 text-sm">
                                        {t("My Profile (Member Since)")}
                                    </p>
                                    <p className="text-2xl font-bold mt-1 text-[#4038FF]">
                                        {date}
                                    </p>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-12 h-12 text-gray-300" aria-hidden="true"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                            </div>
                        </div>
                    </div>
                </Link>

            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {menuItems.map((item, index) => {
                    return <Link key={index} to={item.href}>
                        <div className="rounded-xl border border-gray-200 bg-white shadow hover:shadow-lg transition-all cursor-pointer group">
                            <div className="p-6">
                                <div className="flex items-center justify-between mb-4">
                                    <div className={`w-12 h-12 rounded-xl bg-gradient-to-br text-white ${item.color} flex items-center justify-center group-hover:scale-110 transition-transform`}>
                                        {item.icon}
                                    </div>
                                </div>
                                <h3 className="text-lg font-semibold text-gray-900 group-hover:text-[#4038FF] transition-colors">
                                    {t(item.label)}
                                </h3>
                            </div>
                        </div>
                    </Link>
                })}
            </div>

        </div>
    )
}

export default Dashboard
/* jshint ignore:end */